
const axios = require('axios');
const https = require('https');

const instance = axios.create({
    baseURL: 'https://eis.erobot.sk:8443/',
    httpsAgent: new https.Agent({ rejectUnauthorized: false })
     //'http://192.168.99.18:8081/eisAttendance/' //'https://eis.erobot.sk:8443/' // 'http://192.168.99.18:8081/eisUser/' // 'http://192.168.99.18:8081/eisFile/' //'http://192.168.99.18:8081/eisUser/' 'http://192.168.99.14:8080/EIS/' //'http://localhost:8080/EIS/' or  'https://eis.erobot.sk:8443/'
});

//https.globalAgent.options.rejectUnauthorized = false;

module.exports = instance;
